"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = { class: "w-full 2xl:container mx-auto p-4 flex flex-col" };
const _hoisted_2 = { class: "filters justify-between lg:items-end" };
const _hoisted_3 = { class: "flex flex-col md:flex-row gap-4" };
const _hoisted_4 = /*#__PURE__*/ (0, vue_2.createElementVNode)("i", { class: "marso-icon-plus" }, null, -1);
const _hoisted_5 = {
    key: 0,
    class: "bg-white mt-5 p-5 mb-4"
};
const _hoisted_6 = { class: "flex flex-col md:flex-row border-b-1 border-gray" };
const _hoisted_7 = { class: "flex items-start w-full md:w-1/2 py-2 md:pr-3.5 uppercase font-bold text-xl" };
const _hoisted_8 = { class: "flex justify-end w-full md:w-1/2 py-2 md:pl-3.5" };
const _hoisted_9 = { key: 0 };
const _hoisted_10 = { key: 1 };
const _hoisted_11 = { class: "flex flex-col md:flex-row pt-3" };
const _hoisted_12 = { class: "flex items-start w-full md:w-2/3 py-2 md:pr-3.5" };
const _hoisted_13 = { class: "w-full lg:w-1/2 text-base" };
const _hoisted_14 = { class: "text-xl font-bold mb-3" };
const _hoisted_15 = { class: "text-xl" };
const _hoisted_16 = { class: "text-xl" };
const _hoisted_17 = { class: "flex flex-row mt-5" };
const _hoisted_18 = { class: "text-base" };
const _hoisted_19 = { class: "grow text-base text-right font-bold" };
const _hoisted_20 = { class: "flex flex-row mt-5" };
const _hoisted_21 = { class: "text-base" };
const _hoisted_22 = {
    key: 0,
    class: "grow text-base text-right font-bold"
};
const _hoisted_23 = {
    key: 1,
    class: "grow text-base text-right font-bold"
};
const _hoisted_24 = { class: "flex flex-row" };
const _hoisted_25 = { class: "text-base" };
const _hoisted_26 = { class: "grow text-base text-right font-bold" };
const _hoisted_27 = { class: "flex flex-row mt-5" };
const _hoisted_28 = { class: "text-base" };
const _hoisted_29 = { class: "grow text-base text-right font-bold" };
const _hoisted_30 = { class: "flex flex-row mt-5" };
const _hoisted_31 = { class: "text-base" };
const _hoisted_32 = { class: "grow text-base text-right font-bold" };
const _hoisted_33 = { class: "flex flex-row" };
const _hoisted_34 = { class: "text-base" };
const _hoisted_35 = { class: "grow text-base text-right font-bold" };
const _hoisted_36 = { class: "flex flex-row" };
const _hoisted_37 = { class: "text-base" };
const _hoisted_38 = { class: "grow text-base text-right font-bold" };
const _hoisted_39 = { class: "flex flex-row mt-5" };
const _hoisted_40 = { class: "text-base" };
const _hoisted_41 = { class: "grow text-base text-right font-bold" };
const _hoisted_42 = { class: "flex justify-end w-full md:w-1/3 py-2 md:pl-3.5" };
const _hoisted_43 = { class: "overflow-y-scroll max-h-[400px] text-base w-full" };
const vue_3 = require("vue");
const Form_1 = require("../../components/Form");
const toastStore_1 = require("../../stores/toast/toastStore");
const i18n_1 = require("../../common/i18n");
const shop_1 = require("../../common/utils/shop");
const customersStore_1 = require("../../stores/customers/customersStore");
const vue_router_1 = require("vue-router");
exports.default = (0, vue_1.defineComponent)({
    __name: 'AdminCustomerImport',
    setup(__props) {
        const router = (0, vue_router_1.useRouter)();
        const toastStore = (0, toastStore_1.useToastStore)();
        const customersStore = (0, customersStore_1.useCustomersStore)();
        const customerId = (0, vue_3.ref)('');
        const existingCustomer = (0, vue_3.ref)(false);
        const customer = (0, vue_3.ref)(null);
        const importCustomer = async (customer) => {
            var _a;
            try {
                const response = await customersStore.importCustomer(router, { customerId: customerId.value });
                if (!response) {
                    toastStore.addErrorToast((_a = (0, i18n_1.trans)("customer_found", "Customer already imported", "customer_import")) !== null && _a !== void 0 ? _a : "Customer already imported");
                }
                else {
                    if (existingCustomer.value) {
                        toastStore.addToast({
                            message: (0, i18n_1.trans)("customer_updated", "Customer updated!", "customer_import"),
                            type: "success",
                            timer: 5,
                        });
                    }
                    else {
                        toastStore.addToast({
                            message: (0, i18n_1.trans)("customer_imported", "Customer imported!", "customer_import"),
                            type: "success",
                            timer: 5,
                        });
                    }
                }
                customer.value = null;
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        const getCustomer = async () => {
            var _a;
            customer.value = null;
            try {
                const response = await customersStore.getCustomerInfo(router, customerId.value);
                if (response.status === 'error') {
                    toastStore.addErrorToast((_a = (0, i18n_1.trans)("no_data", "There is no data", "customer_import")) !== null && _a !== void 0 ? _a : "There is no data");
                }
                else {
                    customer.value = response.success;
                    existingCustomer.value = response.existingCustomer;
                }
            }
            catch (error) {
                toastStore.addErrorToast(error.toString());
            }
        };
        return (_ctx, _cache) => {
            return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_1, [
                (0, vue_2.createElementVNode)("div", _hoisted_2, [
                    (0, vue_2.createElementVNode)("div", _hoisted_3, [
                        (0, vue_2.createVNode)((0, vue_2.unref)(Form_1.ShopInput), {
                            type: "text",
                            name: "id",
                            placeholder: (0, vue_2.unref)(i18n_1.trans)('customer_id_placeholder', 'ID', 'customer_import'),
                            label: (0, vue_2.unref)(i18n_1.trans)('customer_id_label', 'Customer ID', 'customer_import'),
                            autofocus: "",
                            required: "",
                            border: "",
                            icon: "marso-icon-user",
                            class: "my-5",
                            modelValue: customerId.value,
                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((customerId).value = $event))
                        }, null, 8, ["placeholder", "label", "modelValue"])
                    ]),
                    (0, vue_2.createElementVNode)("button", {
                        class: "btn btn-rounded btn-primary",
                        onClick: _cache[1] || (_cache[1] = ($event) => (getCustomer()))
                    }, [
                        _hoisted_4,
                        (0, vue_2.createTextVNode)(" " + (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("get_customer", "Get customer", "customer_import")), 1)
                    ])
                ]),
                (customer.value)
                    ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_5, [
                        (0, vue_2.createElementVNode)("div", _hoisted_6, [
                            (0, vue_2.createElementVNode)("div", _hoisted_7, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("customer_data", "Customer Data", "customer_import")), 1),
                            (0, vue_2.createElementVNode)("div", _hoisted_8, [
                                (0, vue_2.createElementVNode)("button", {
                                    class: "btn btn-rounded btn-warning",
                                    onClick: _cache[2] || (_cache[2] = ($event) => (importCustomer(customer.value)))
                                }, [
                                    (existingCustomer.value)
                                        ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_9, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("update", "Update customer", "customer_import")), 1))
                                        : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_10, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("import", "Import customer ", "customer_import")), 1))
                                ])
                            ])
                        ]),
                        (0, vue_2.createElementVNode)("div", _hoisted_11, [
                            (0, vue_2.createElementVNode)("div", _hoisted_12, [
                                (0, vue_2.createElementVNode)("div", _hoisted_13, [
                                    (0, vue_2.createElementVNode)("div", _hoisted_14, (0, vue_2.toDisplayString)(customer.value.customerName), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_15, (0, vue_2.toDisplayString)(customer.value.customerZip + ", " + customer.value.customerCity), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_16, (0, vue_2.toDisplayString)(customer.value.customerStreet), 1),
                                    (0, vue_2.createElementVNode)("div", _hoisted_17, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_18, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("department", "Department", "customer_import")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_19, (0, vue_2.toDisplayString)(customer.value.department), 1)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_20, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_21, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("payment_mode", "Payment mode", "customer_import")), 1),
                                        (customer.value.paymentMode != '')
                                            ? ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_22, (0, vue_2.toDisplayString)(customer.value.paymentMode), 1))
                                            : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", _hoisted_23, " - "))
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_24, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_25, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("payment_name", "Payment name", "customer_import")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_26, (0, vue_2.toDisplayString)(customer.value.paymentConditionName), 1)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_27, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_28, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("payment_deadline", "Payment deadline", "customer_import")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_29, (0, vue_2.toDisplayString)(customer.value.paymentDeadlineInDays), 1)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_30, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_31, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("mandatory_credit_limit", "Mandatory credit limit", "customer_import")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_32, (0, vue_2.toDisplayString)(customer.value.MandatoryCreditLimit ? (0, vue_2.unref)(i18n_1.trans)("yes", "Yes", "customer_import") : (0, vue_2.unref)(i18n_1.trans)("no", "No", "customer_import")), 1)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_33, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_34, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("primary_credit_limit", "Primary credit limit", "customer_import")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_35, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(parseFloat(customer.value.creditMax), customer.value.currencyCode)), 1)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_36, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_37, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("secondary_credit_limit", "Secondary credit limit", "customer_import")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_38, (0, vue_2.toDisplayString)((0, vue_2.unref)(shop_1.formatPrice)(parseFloat(customer.value.creditMax2), customer.value.currencyCode)), 1)
                                    ]),
                                    (0, vue_2.createElementVNode)("div", _hoisted_39, [
                                        (0, vue_2.createElementVNode)("div", _hoisted_40, (0, vue_2.toDisplayString)((0, vue_2.unref)(i18n_1.trans)("currency", "Currency", "customer_import")), 1),
                                        (0, vue_2.createElementVNode)("div", _hoisted_41, (0, vue_2.toDisplayString)(customer.value.currencyCode), 1)
                                    ])
                                ])
                            ]),
                            (0, vue_2.createElementVNode)("div", _hoisted_42, [
                                (0, vue_2.createElementVNode)("div", _hoisted_43, [
                                    ((0, vue_2.openBlock)(true), (0, vue_2.createElementBlock)(vue_2.Fragment, null, (0, vue_2.renderList)(customer.value.customerAddresses, (customerAddress, key) => {
                                        return ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                                            key: key,
                                            class: "mb-3 border-b-1 border-gray"
                                        }, [
                                            (0, vue_2.createElementVNode)("div", null, [
                                                (0, vue_2.createElementVNode)("b", null, (0, vue_2.toDisplayString)(customerAddress.addressName), 1),
                                                (0, vue_2.createTextVNode)("(" + (0, vue_2.toDisplayString)(customerAddress.addressType) + ") ", 1)
                                            ]),
                                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(customerAddress.zip + " " + customerAddress.city), 1),
                                            (0, vue_2.createElementVNode)("div", null, (0, vue_2.toDisplayString)(customerAddress.street), 1)
                                        ]));
                                    }), 128))
                                ])
                            ])
                        ])
                    ]))
                    : (0, vue_2.createCommentVNode)("", true)
            ]));
        };
    }
});
